import { render, staticRenderFns } from "./Elderly.vue?vue&type=template&id=7d774c30&"
import script from "./Elderly.vue?vue&type=script&lang=js&"
export * from "./Elderly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports